import locale from '@glu/locale';
import { darkModeAware } from '@glu/theming';
import classnames from 'classnames';

import useStyles from './OptionalInlineText.styles';

export interface IOptionalInlineTextProps {
  /** Indicates if styles should use dark mode */
  dark?: boolean;
  /** Indicates if styles should use error class */
  hasError?: boolean;
  /** Indicates if styles should use warning class */
  warning?: boolean;
  /** Indicates if styles should use textarea class */
  withTextarea?: boolean;
}

const OptionalInlineText = ({
  dark,
  hasError,
  warning,
  withTextarea,
}: IOptionalInlineTextProps) => {
  const classes = useStyles();
  return (
    <span
      className={classnames(classes.root, {
        [classes.dark]: dark,
        [classes.error]: hasError,
        [classes.warning]: warning,
        [classes.textarea]: withTextarea,
      })}
      data-qa="optional-inline-span"
    >
      {locale.get('optional')}
    </span>
  );
};

export default darkModeAware(OptionalInlineText);
